import { privateApi } from '@/config';
import type {
  FunnelStagesResponse,
  FunnelStageResponse,
  FunnelStageValuesResponse,
} from '../types/crm-types';

export const funnelApi = {
  // Obtener todas las etapas del funnel
  getFunnelStages: async (): Promise<FunnelStagesResponse> => {
    const response = await privateApi.get('/crm/funnel/stages');
    return response.data;
  },

  // Obtener información de una etapa específica
  getFunnelStageInfo: async (stage: string): Promise<FunnelStageResponse> => {
    const response = await privateApi.get(`/crm/funnel/stages/${stage}`);
    return response.data;
  },

  // Obtener valores de las etapas
  getFunnelStageValues: async (): Promise<FunnelStageValuesResponse> => {
    const response = await privateApi.get('/crm/funnel/stages/values');
    return response.data;
  },
};
